import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API = process.env.VUE_APP_API_URL;

export default {
  list(params = {}) {
    return axios.get(`${API}attendance/records`, {
      params,
      headers: buildHeaders(),
    });
  },
  today(params = {}) {
    return axios.get(`${API}attendance/today`, {
      params,
      headers: buildHeaders(),
    });
  },
  getAttendanceSettings() {
    return axios.get(`${API}attendance/settings`, {
      headers: buildHeaders(),
    });
  },
  punchIn(payload = {}) {
    return axios.post(`${API}attendance/punch-in`, payload, {
      headers: buildHeaders(),
    });
  },
  punchOut(payload = {}) {
    return axios.post(`${API}attendance/punch-out`, payload, {
      headers: buildHeaders(),
    });
  },
  destroy(id) {
    return axios.delete(`${API}attendance/records/${id}`, {
      headers: buildHeaders(),
    });
  },

  update(id, payload = {}) {
    return axios.put(`${API}attendance/records/${id}`, payload, {
      headers: buildHeaders(),
    });
  },

  getMySchedule(params = {}) {
    return axios.get(`${API}attendance/my-schedule`, {
      params,
      headers: buildHeaders(),
    });
  },

  getMyUpcomingSchedule(params = {}) {
    return axios.get(`${API}attendance/my-upcoming`, {
      params,
      headers: buildHeaders(),
    });
  },

  getMySummary(params = {}) {
    return axios.get(`${API}attendance/my-summary`, {
      params,
      headers: buildHeaders(),
    });
  },

  updateAttendanceSettings(payload = {}) {
    return axios.put(`${API}attendance/settings`, payload, {
      headers: buildHeaders(),
    });
  },
};
